import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { withNamespaces } from 'react-i18next';
import TabPanelSurveyDetail from './TabPanelSurveyDetail';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import i18next from 'i18next';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';

import { getSurveyDetail } from '../../actions/survey';
import * as StatusCode from '../../scripts/StatusCode';
import * as StatusSurvey from '../../scripts/StatusSurveyCode'

import styles from '../../styles/survey.module.css';

const useStyles = makeStyles((theme) => ({
    appBar: {
        top: 'auto',
        bottom: 0,
        height: '35px!important'
    },
    toolBar: {
        flex: 1,
        minHeight: 'unset!important',
        alignSelf: 'center'
    },
    titleTemplate: {
        fontSize: '20px',
        '@media (max-width: 600px)': {
            fontSize: '15px',
        }
    },
    icon: {
        marginRight: '5px'
    },
    completed: {
        color: '#5ad75a'
    },
    expired: {
        color: '#ff5f5f'
    }
}));

export function SurveyDetail(props) {
    const classes = useStyles();

    const [surveyId, setSurveyId] = useState(props.surveyId);
    const [data, setData] = useState(null);
    const [labelStatus, setLabelStatus] = useState('');
    const [iconStatus, setIconStatus] = useState(null);
    const [cssStatus, setCssStatus] = useState('');

    useEffect(() => {
        loadDetail();
    }, []);

    useEffect(() => {
        setSurveyId(props.surveyId);
    }, [props.surveyId]);

    useEffect(() => {
        if (data != null) {
            handleStatusLabel();
        }
    }, [data]);

    const loadDetail = async (loadParent = false) => {
        const response = await getSurveyDetail(surveyId);

        if (response != null && response.status == StatusCode.STATUS_OK) {
            setData(response.result);
        } else {
            showMessageError(i18next.t('error:generic-error'));
        }

        if (loadParent) {
            props.reloadList();
        }
    }

    const handleStatusLabel = () => {
        const status = data.survey.status;

        switch (status) {
            case StatusSurvey.IntStatus_Completed:
                setLabelStatus(i18next.t('survey:status.labelCompleted'));
                setIconStatus(<CheckCircleOutlineIcon />);
                setCssStatus(classes.completed);
                break;
            case StatusSurvey.IntStatus_Expired:
                setLabelStatus(i18next.t('survey:status.labelExpired'));
                setIconStatus(<HighlightOffIcon />);
                setCssStatus(classes.expired);
                break;
            default:
                setLabelStatus('');
        }
    }

    return (
        <div>
            {labelStatus != '' && <AppBar position="fixed" className={classes.appBar}>
                <Toolbar className={classes.toolBar + ' ' + cssStatus}>
                    <span className={classes.icon}>{iconStatus}</span><span className={classes.status}>{labelStatus}</span>
                </Toolbar>
            </AppBar>}

            <TabPanelSurveyDetail data={data} handleLoadSurvey={loadDetail} />
        </div>
    );
}

export default withNamespaces(['survey', 'error'], { wait: true })(SurveyDetail);